import * as Yup from "yup";

export const headerRender = [
  [
    {
      name: "customerCode",
      label: "Customer Code",
      type: "text",
      errorMsg: "Customer Code is Required.",
      required: true,
      disabled: true,
    },
  ],
];

export const detailRender = [
  [
    {
      name: "customerCode",
      label: "Customer Code",
      type: "text",
      errorMsg: "Customer Code is Required.",
      required: true,
      disabled: true,
    },
  ],
  [
    {
      name: "shippingZone",
      label: "Shipping Zone",
      type: "select",
      errorMsg: "Shipping Zone is Required.",
      required: true,
      editable: false,
      // edit: true,
    },
  ],
  [
    {
      name: "carrierCode",
      label: "Carrier Code",
      type: "select",
      errorMsg: "Carrier Code is Required.",
      required: true,
      // edit: true,
    },
  ],
  [
    {
      name: "b2BCarrierCode",
      label: "B2B Carrier Code",
      type: "select",
      errorMsg: "B2B Carrier Code is Required.",
      // required: true,
      // edit: true,
    },
  ],
];

export const formRender = [
  [
    {
      name: "customerCode",
      label: "Customer Code",
      type: "text",
      errorMsg: "Customer Code is Required.",
      required: true,
      disabled: true,
    },
    {
      name: "shippingZone",
      label: "Shipping Zone",
      type: "select",
      errorMsg: "Shipping Zone is Required.",
      required: true,
      editable: false,
    },
    {
      name: "carrierCode",
      label: "Carrier Code",
      type: "select",
      errorMsg: "Carrier Code is Required.",
      required: true,
    },
    {
      name: "b2BCarrierCode",
      label: "B2B Carrier Code",
      type: "select",
      errorMsg: "B2B Carrier Code is Required.",
      // required: true,
    },
  ],
];

export const headerValue = {
  customerCode: null,
};

export const detailValue = {
  //no: null,
  customerCode: null,
  shippingZone: null,
  carrierCode: null,
  b2BCarrierCode: null,
};

export const initialValues = {
  customerCode: null,
  shippingZone: null,
  carrierCode: null,
  b2BCarrierCode: null,
};

export const headerValidation = Yup.object().shape({
  //no: Yup.number(),
  customerCode: Yup.string().required("Customer Code is Required."),
});

export const detailValidation = Yup.object().shape({
  //no: Yup.number(),
  customerCode: Yup.string().nullable().required("Customer Code is Required."),
  shippingZone: Yup.string().nullable().required("Shipping Zone is Required."),
  carrierCode: Yup.string().nullable().required("Carrier Code is Required."),
  // b2BCarrierCode: Yup.string().nullable().required("B2B Carrier Code is Required."),
});

export const custCarrierValidations = Yup.object().shape({
  //no: Yup.number(),
  customerCode: Yup.string().nullable().required("Customer Code is Required."),
  shippingZone: Yup.string().nullable().required("Shipping Zone is Required."),
  carrierCode: Yup.string().nullable().required("Carrier Code is Required."),
  // b2BCarrierCode: Yup.string().nullable().required("B2B Carrier Code is Required."),
});